import I18n from 'I18n';
import allSettled from 'framework-asset-preview-lib/internal/shared/utils/allSettled';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import { getBatchPlacementAnalytics } from './api';
const PLACEMENT_TYPES = {
  DEFAULT: 'DEFAULT',
  CONTACT_LIST: 'CONTACT_LIST',
  CONTACT_LIFECYCLE: 'CONTACT_LIFECYCLE',
  GEO_IP: 'GEO_IP',
  DEVICE_TYPE: 'DEVICE_TYPE',
  TRAFFIC_SOURCE: 'TRAFFIC_SOURCE',
  LANGUAGE: 'LANGUAGE',
  VARIATION: 'VARIATION',
  VIDEO: 'VIDEO'
};
export function getNonCrmPropertyValue(propertyName, nonCrmObject) {
  if (!nonCrmObject) {
    return undefined;
  }
  const ctaResponse = nonCrmObject;
  if (propertyName in ctaResponse) {
    return ctaResponse[propertyName];
  }
  return undefined;
}
export function isSmart(type) {
  return [PLACEMENT_TYPES.CONTACT_LIST, PLACEMENT_TYPES.CONTACT_LIFECYCLE, PLACEMENT_TYPES.GEO_IP, PLACEMENT_TYPES.DEVICE_TYPE, PLACEMENT_TYPES.TRAFFIC_SOURCE, PLACEMENT_TYPES.LANGUAGE].includes(type);
}
export function isVariation(type) {
  return type === PLACEMENT_TYPES.VARIATION;
}
export function isVideo(type) {
  return type === PLACEMENT_TYPES.VIDEO;
}
export function getCtaPerformanceStats(crmObject) {
  const assetId = getPropertyValue(crmObject, 'hs_origin_asset_id');
  return allSettled([getBatchPlacementAnalytics(crmObject)]).then(response => {
    const [ctaAnalyticsResponse] = response;
    const ctaAnalytics = {
      ctaClicks: 0,
      ctaRate: 0,
      ctaViews: 0
    };
    if (ctaAnalyticsResponse.status === 'fulfilled' && ctaAnalyticsResponse.value[`${assetId}`].length) {
      const [stats] = ctaAnalyticsResponse.value[`${assetId}`];
      ctaAnalytics.ctaClicks = stats.ctaClicks;
      ctaAnalytics.ctaRate = stats.ctaRate;
      ctaAnalytics.ctaViews = stats.ctaViews;
    }
    const overviewPerfGroup = {
      stats: [{
        formatStyle: 'decimal',
        propertyName: 'hs_placement_views',
        value: ctaAnalytics.ctaViews
      }, {
        formatStyle: 'percentage',
        propertyName: 'hs_placement_click_rate',
        value: ctaAnalytics.ctaRate * 100
      }, {
        formatStyle: 'decimal',
        propertyName: 'hs_placement_clicks',
        value: ctaAnalytics.ctaClicks
      }],
      title: I18n.text('frameworkAssetPreviewLib.tabs.performance.performanceGroup.0-42.overview')
    };
    return [overviewPerfGroup];
  });
}